import src from "IMAGE";
export default { src, width: 313, height: 63, blurWidth: 0, blurHeight: 0};
